'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append('<div class="contact-us-signup-message"></div>');
    }
    $('.contact-us-signup-message').append(
        '<div class="contact-us-signup-alert text-center ' +
			status +
			'" role="alert">' +
			data.msg +
			'</div>'
    );

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');
            var recaptchaSiteKey = form.find('button').data('site-key');
            var formData = form.serialize();
            var replacedHTML =
				'<p class="font-weight-bold">Your message has been sent.</p><p class="font-weight-bold">A customer service specialist will contact you shortly!</p>';
            $.spinner().start();
            button.attr('disabled', true);
            // eslint-disable-next-line no-undef
            grecaptcha.ready(function () {
                // eslint-disable-next-line no-undef
                grecaptcha
                    .execute(recaptchaSiteKey, { action: 'submit' })
                    .then(function (token) {
                        // Add your logic to submit to your backend server here.
                        formData += '&recaptchaToken=' + token;
                        $.ajax({
                            url: url,
                            type: 'post',
                            dataType: 'json',
                            data: formData,
                            success: function (data) {
                                displayMessage(data, button);
                                if (data.success) {
                                    var $outer = $('.contact-us-landing-page .card-body');
                                    var $container = $('html,body');
                                    $outer.addClass('text-center');
                                    $outer.html(replacedHTML);
                                    $container.animate(
                                        {
                                            scrollTop:
												$outer.offset().top -
												$('.site-main-header').height() -
												50,
                                            scrollLeft: 0,
                                        },
                                        300
                                    );
                                    $(
                                        '.contact-us-landing-page .continue-shopping-btn'
                                    ).removeClass('d-none');
                                }
                            },
                            error: function (err) {
                                displayMessage(err, button);
                            },
                        });
                    });
            });
        });
    },
};
